import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Main from "../../layout/main";
import * as actions from "../../store/actions";
import * as configActions from "../../store/config/actions";
import { SchoolsService } from "../../services/competitions";
import Header from "../../components/common/secondary header/index";
import { Mixpanel } from "../../services/Mixpanel";
import "./style.scss";
import { textIdentifier } from "../../textIdentifier";

const SchoolsList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedCompetition = useSelector(
    (state) => state.main.selectedCompetition
  );
  const { userData } = useSelector((state) => state.auth);
  const [schools, setSchools] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredSchools, setFilteredSchools] = useState(schools);
  const {lang} = useSelector(state => state.main)

  const handleFetchSchoolList = async () => {
    try {
      const res = await SchoolsService(selectedCompetition.id);
      setSchools(res.data);
      Mixpanel.track("Competition_Admin_Schools_Viewed", {
        CompetitionID: selectedCompetition?.id,
        CompetitionName: selectedCompetition?.name,
      });
      Mixpanel.people.set({
        $email: userData?.email,
        $distinct_id: userData?.id,
      });
      Mixpanel.people.increment({
        "#NumberOfTimesSchoolViewed": 1,
      });
    } catch (error) {
      dispatch(configActions.showAlert(error?.data?.message));
    }
  };

  useEffect(() => {
    if (!selectedCompetition) {
      navigate("/");
    } else {
      handleFetchSchoolList();
    }
  }, []);

  const selectSchool = (school) => {
    dispatch(actions.selectSchool(school));
    navigate(`/schools/${school.id}/classes`);
  };

  useEffect(() => {
    if (searchText) {
      setFilteredSchools(
        schools.filter((school) =>
          school.name.toLowerCase().includes(searchText.toLowerCase())
        )
      );
      Mixpanel.track("Competition_Admin_Schools_searched", {
        CompetitionID: selectedCompetition?.id,
        CompetitionName: selectedCompetition?.name,
        Searchword: searchText,
      });
      Mixpanel.people.set({
        $email: userData?.email,
        $distinct_id: userData?.id,
      });
    } else {
      setFilteredSchools(schools);
    }
  }, [searchText, schools]);

  const startTime = new Date(selectedCompetition?.start_time);
  const endTime = new Date(selectedCompetition?.end_time);

  const renderTimeStringJSX = (start_time, end_time) => {
    const startTime = new Date(start_time);
    const endTime = new Date(end_time);

    function getDateString(date) {
      if(!date)
        return;
      const d = new Date(date).toJSON();
      return d && d.split("T")[0].split("-").reverse().join("-");
    }

    return (
      <Fragment>
        <span>{getDateString(startTime)} </span>
        <span className="text-primary">
          {startTime
            .toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })
            .toLowerCase()}{" "}
        </span>
        <span>to </span>
        <span>{getDateString(endTime)} </span>
        <span className="text-primary">
          {endTime
            .toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })
            .toLowerCase()}{" "}
        </span>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Header />
      <Main className="competition-schools">
        <div className="cr-wrapper-card">
          <div className="cr-card-header justify-content-start">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 35 35"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21.78 3.66699H10.2213C6.1933 3.66699 3.66797 6.51899 3.66797 10.555V21.4457C3.66797 25.4817 6.17997 28.3337 10.2213 28.3337H21.7786C25.82 28.3337 28.3346 25.4817 28.3346 21.4457V10.555C28.3346 6.51899 25.82 3.66699 21.78 3.66699Z"
                  stroke="#2E2E2E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 11V16.3333L20 20.3333"
                  stroke="#2E2E2E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="mx-1">{textIdentifier['from'][lang]} :</span>
            </div>
            <div>{renderTimeStringJSX(startTime, endTime)}</div>
          </div>
          {selectedCompetition && (
            <h5 className="cr-card-title">{selectedCompetition.name}</h5>
          )}
          <div className="cr-card">
            <div className="header list-header-container">
              <div className="flex-items">
                <span>{textIdentifier['no'][lang]}.</span>
                <span>{textIdentifier['schools'][lang]}</span>
              </div>
              <div className="cr-search-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M19 19L13 13L19 19ZM15 8C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.82951 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8Z"
                    stroke="#2E2E2E"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <input
                  className="form-control"
                  placeholder={textIdentifier["search-by-school-name"][lang]}
                  name="search"
                  id="search"
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>
            <ul className="list-group">
              {filteredSchools.map((school, index) => (
                <React.Fragment key={school.id}>
                  <li className="list-group-item list-item">
                    <div className="flex-items">
                      <span>{index + 1}</span>
                      <span>{school.name}</span>
                      <span>({school.code})</span>
                    </div>
                    <button
                      onClick={() => selectSchool(school)}
                      className="btn-contained m-0"
                    >
                      {textIdentifier['view-classes'][lang]}
                    </button>
                  </li>
                  <hr className="underline" />
                </React.Fragment>
              ))}

              <li className="list-group-item list-item">
                <div className="flex-items d-block">
                  <span className="mx-2 font-weight-bold">
                    {textIdentifier['total-schools'][lang]} : {filteredSchools.length}
                  </span>
                </div>
              </li>
              <hr className="underline" />
            </ul>
          </div>
        </div>
      </Main>
    </Fragment>
  );
};

export default SchoolsList;
